






































































































import { WorkRecordReportServiceProxy} from "@/service-proxies/app-v2/work-record.service-proxies";
import { CustomerServiceProxy } from "@/service-proxies/app-v2/client.service-proxies";
import { MachineServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { DictBizServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const customerService = new CustomerServiceProxy();
const machineService = new MachineServiceProxy();
const dictBizService = new DictBizServiceProxy();
const wrkRecordReportServiceProxy = new WorkRecordReportServiceProxy()
let timeout;
let currentValue;
let currentMachineCodeValue;
let currentMachineNameValue;

function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function getCustomers() {
    customerService.getCustomers(value, '').then((result) => {
      if (currentValue === value) {
        const data = [];
        result.forEach((r) => {
          let address = '';
          if (r["provinceName"]) {
            if (r["provinceName"] === r["cityName"]) {
              address =  r["provinceName"] +`-`+r["address"];
            }else{
              address = r["provinceName"] +`-`+r["cityName"]+`-`+r["address"];
            }
          }
          data.push({
            value: r["id"],
            text: r["name"],
            address: address,
          });
        });
        callback(data);
      }
    });
  }

  timeout = setTimeout(getCustomers, 120);
}

function fetchMachineCodes(value, customerId, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentMachineCodeValue = value;

  function getWorkstations() {
    machineService
        .getMachineSelectList(customerId, undefined, value)
        .then((d) => {
          if (currentMachineCodeValue === value) {
            const result = d;
            const data = [];
            result.forEach((r) => {
              data.push({
                value: r["id"],
                text: r["serialNo"],
                name: r["name"] + "(" + r["serialNo"] + ")",
              });
            });
            callback(data);
          }
        });
  }

  timeout = setTimeout(getWorkstations, 120);
}

function fetchMachineNames(value, customerId, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentMachineNameValue = value;

  function getWorkstations() {
    machineService
        .getMachineSelectList(customerId, value, undefined)
        .then((d) => {
          if (currentMachineNameValue === value) {
            const result = d;
            const data = [];
            result.forEach((r) => {
              data.push({
                value: r["id"],
                text: r["serialNo"],
                name: r["name"] + "(" + r["serialNo"] + ")",
              });
            });
            callback(data);
          }
        });
  }

  timeout = setTimeout(getWorkstations, 120);
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: Object,
  },
  async created() {
    let res = await dictBizService.dictionary("job-type");
    this.jobTypeList = res.data;
    res = await dictBizService.dictionary("industry-type");
    this.industryTypeList = res.data;
  },
  data() {
    return {
      labelCol: {span: 6},
      wrapperCol: {span: 18},
      form: {
        customerId: undefined,
        customerAddress: "",
        currentMachine: undefined,
      },
      data: [],
      machineInfo: [],
      rules: {
        customerId: [
          {
            required: true,
            message: this.$t("page_ops_work_record_customer_required"),
            trigger: "change",
          },
        ],
        currentMachine: [
          {
            required: true,
            message: this.$t("page_ops_work_record_machine_required"),
            trigger: "change",
          },
        ]
      },
      loading: false,
    };
  },
  watch: {
    editData: {
      handler(val) {
        fetchCustomers('', (data) => {
          console.log(999,data)
          this.data = data
          const {currentMachine, customerId, workRecordId, customerAddress} = val;
          this.form.customerId = String(customerId);
          this.form.workRecordId = workRecordId;
          fetchMachineNames(
              '',
              customerId,
              (data) => {
                this.machineInfo = data;
                this.form.currentMachine = String(currentMachine);
              }
          );
          this.form.customerAddress = customerAddress;
        });
      },
      deep: true
    }
  },
  computed: {
    address() {
      if (this.form.customerAddress) {
        const {provinceName, cityName, address} = this.form.customerAddress;
        let showAddress = ''
        if(provinceName){
          if(provinceName === cityName){
            showAddress =  `${provinceName}${cityName}`
          } else {
            showAddress = `${provinceName}${cityName}${address}`
          }
        }
        return showAddress
      } else {
        return '';
      }
    }
  },
  methods: {
    handleCustomerSearch(value) {
      value = value === undefined ? "" : value;
      fetchCustomers(value, (data) => (this.data = data));
    },
    handleCustomerChange(value) {
      value = value === undefined ? "" : value;
      this.form.customerId = value;
      this.machineInfo = [];
      this.form.currentMachine = undefined;
      // id 获取地址
      const customerItem = this.data.find((v) => v.value === value);
      this.form.customerAddress = customerItem.address;
    },
    handleMachineNameSearch(value) {
      value = value === undefined ? "" : value;
      fetchMachineNames(
          value,
          this.form.customerId,
          (data) => (this.machineInfo = data)
      );
    },
    handleMachineNameChange(value) {
      value = value === undefined ? "" : value;
      this.form.currentMachine = value;
      fetchMachineNames(
          value,
          this.form.customerId,
          (data) => (this.machineInfo = data)
      );
    },
    handleMachineSerialNoSearch(value) {
      value = value === undefined ? "" : value;
      fetchMachineCodes(
          value,
          this.form.customerId,
          (data) => (this.machineInfo = data)
      );
    },
    handleMachineSerialNoChange(value) {
      value = value === undefined ? "" : value;
      this.form.currentMachine = value;
      fetchMachineCodes(
          value,
          this.form.customerId,
          (data) => (this.machineInfo = data)
      );
    },
    save() {
      if (this.loading) {
        return;
      }
      this.$refs.newWorkRecord.validate((valid) => {
        if (valid) {
          this.form.workstationId = this.form.currentMachine;
          wrkRecordReportServiceProxy.update(this.form).then(_=>{
            this.$message.success(this.$t("success"));
            this.$emit("ok");
          })
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
  }
};
